import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function KeyboardVoiceIcon(props: IconProps) {
    return <Icon {...props} iconKey={"keyboard_voice"}/>
}
